import RadarChartComp from '../RadarChart/RadarChartComp';
import { useTranslation } from 'react-i18next';
import ChartDescription, {
  ChartPoint
} from '../CompetenciesBlock/ChartDescription';
import React, { useMemo } from 'react';
import './index.scss';

function CompareChart({
  names,
  minScores,
  descriptions,
  comparePoints,
  title,
  className,
  percent,
  showDescription = true
}: any) {
  const { t } = useTranslation();

  // Process data for chart description
  const chartPoints: ChartPoint[] = useMemo(() => {
    if (!names || !minScores) return [];

    // Create an array with the same order as displayed in the radar chart
    return names.map((name: string, index: number) => {
      // Make sure comparison point is a primitive value, not an object
      let comparisonPoint;
      const rawPoint = comparePoints?.[index];

      if (rawPoint && typeof rawPoint === 'object') {
        // Extract the score from the object if it's an object
        comparisonPoint = rawPoint.score || rawPoint.value || 0;
      } else {
        // Use the value directly if it's already a primitive
        comparisonPoint = rawPoint || 0;
      }

      return {
        label: name,
        point: minScores[index] || 0,
        descriptions:
          descriptions?.[index]?.description || descriptions?.[index] || '',
        comparePoint: comparisonPoint
      };
    });
  }, [names, minScores, descriptions, comparePoints]);

  // Check if we have enough data to show the chart description
  const hasValidData = useMemo(() => {
    return (
      names &&
      names.length > 0 &&
      minScores &&
      minScores.length > 0 &&
      descriptions
    );
  }, [names, minScores, descriptions]);

  return (
    <div className={`competenciesb ${className || ''}`}>
      <div className="competenciesb__top">
        <div
          className="competenciesb__top__left"
          style={{ alignItems: 'start' }}
        >
          <span
            className="competenciesb__top__left-title"
            style={{ color: 'black' }}
          >
            {title}
          </span>
          {percent !== undefined && percent !== null && (
            <span className="competenciesb__top__left-percent">
              {isNaN(Number(percent)) ? 0 : percent}%
            </span>
          )}
        </div>
        <div className="competenciesb__top__right">
          <div className="competenciesb__top__right__item">
            <span className="competenciesb__top__right__item-dot purple"></span>
            <span className="competenciesb__top__right__item-title">
              {t('Job')}
            </span>
          </div>
          <div className="competenciesb__top__right__item">
            <span className="competenciesb__top__right__item-dot"></span>
            <span className="competenciesb__top__right__item-title">
              {t('Candidate')}
            </span>
          </div>
        </div>
      </div>
      <div className="competenciesb__chart">
        <RadarChartComp
          boxSx={{ width: '100%' }}
          labels={names}
          points={minScores || []}
          descriptions={descriptions}
          comparePoints={comparePoints}
          assessment={true}
          chartHeight={500}
          chartWidth={500}
        />
      </div>

      {/* Chart Description Section */}
      {showDescription && hasValidData && chartPoints.length > 0 && (
        <ChartDescription labels={chartPoints} />
      )}
    </div>
  );
}

export default CompareChart;
